import React, { useRef, useState, useEffect } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import AddIcon from '@mui/icons-material/Add'
import CloseIcon from '@mui/icons-material/Close'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import DraggableGridLayout from '../ui/DraggableGridLayout'
import LoadingSpinner from '../../components/ui/LoadingSpinner'
import { closePopup } from '../../actions/uiActions'
import { updateStory, getPresentationSlideImage } from '../../actions/presentationActions'
import { withRouter } from '../../actions/withRouterHook'
import { PLACEHOLDER_IMAGE_BYTES } from '../ui/helpers/PlaceholderImageConstant'

function EditStoryPopup(props) {
    let navigate = useNavigate()
    let [needsToLoad, setNeedsToLoad] = useState(true)
    let [forceUpdate, setForceUpdate] = useState(false)
    let [includedSlides, setIncludedSlides] = useState([])
    let [excludedSlides, setExcludedSlides] = useState([])
    let [sections, setSections] = useState([])
    let [width, setWidth] = useState(1300)
    let [slidesLoaded, setSlidesLoaded] = useState(0)
    let popupContainerRef = useRef(null)

    // trigger on component mount
    useEffect(() => {
        if (needsToLoad && props.presentationSlideChanges.includedTags) {
            buildIncludedRegion(props.presentationSlideChanges,true)
            buildExcludedRegion(props.presentationSlideChanges,true)
            handleResize()
            window.addEventListener('resize', handleResize)
            setNeedsToLoad(false)
        }
    })
    useEffect(() => {
        if (props.presentationSlideChanges.includedTags) { 
            buildIncludedRegion(props.presentationSlideChanges,false)
            buildExcludedRegion(props.presentationSlideChanges,false)
        }
    }, [slidesLoaded])
    useEffect(() => {
        if (forceUpdate) {
            setForceUpdate(false)
            handleResize()
        }
    }, [forceUpdate])
    useEffect(() => {
        window.removeEventListener('resize', handleResize);
    }, [])

    if (needsToLoad) {
        return (
            <Dialog
                open={true}
                maxWidth={'md'}
                onClose={handleClick}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="slides-history"
            >
                <CloseIcon onClick={handleClick} className="closePoup" />
                <DialogContent>
                    <LoadingSpinner loadingMessage="Loading All Slides..." />
                </DialogContent>
            </Dialog>
        )
    } else {
        return (
            <Dialog
                open={true}
                maxWidth={'md'}
                fullScreen={true}
                onClose={handleClick}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="edit-story-presentation"
                ref={popupContainerRef}
            >
                <CloseIcon onClick={handleClick} className="closePoup" />
                <DialogTitle id="alert-dialog-title" className="changepassdialog">
                    Edit Story Presentation
                </DialogTitle>
                <DialogContent id="alert-dialog-description" className="edit-story-content">
                    <Typography variant="h5" gutterBottom component="div">Slides In Presentation</Typography>
                    <div>
                        <button className="btn" type="submit" onClick={handleSubmit} value="Update Story" id="submit_btn" style={{ marginBottom: 5 }}>
                            Update Story
                        </button>
                    </div>
                    <div className="selections">
                        <DraggableGridLayout
                            data={includedSlides}
                            identifier="tag"
                            width={width}
                            contextMenuCommands={["delete slide", "duplicate slide"]}
                            onReorder={handleReorderBubbleEvent}
                            onDelete={handleDelete}
                            onDuplicate={handleCopy}
                            slidesLoaded={slidesLoaded}>
                        </DraggableGridLayout>
                    </div>
                    <Typography variant="h5" gutterBottom component="div">Slides Excluded From Presentation</Typography>
                    {sections.map((section, sIndex) => {
                        return (<Accordion key={`excluded-accordion-${sIndex}`}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls={`panel-exclude-content-${sIndex}`}
                                id={`panel-exclude-${sIndex}`}
                            >
                                <Typography style={{ fontSize: 15, fontWeight: 400 }}>{section.name}</Typography>
                            </AccordionSummary>
                            <AccordionDetails className="excluded">
                                <Grid container className="selections">
                                    {section.slides.map((slide, slideIndex) => {
                                        return (<Grid item xs={3} className="tag-selection" key={`item-exc-index-${sIndex}-${slideIndex}`}>
                                            <Typography>{slide.tag}</Typography>
                                            <img className="slideImg" src={`data:image/jpeg;base64,${slide["imageBytes"]}`} alt={`slide_${sIndex}_${slideIndex}`} />
                                            <AddIcon className="delete" fontSize="small" onClick={(e) => handleAdd(e, slide.tag)} />
                                            <Typography>{slide.description}</Typography>
                                        </Grid>);
                                    })}
                                </Grid>
                            </AccordionDetails>
                        </Accordion>);
                    })}
                </DialogContent>
            </Dialog>)
    }

    //#region Event Handlers
    function handleClick(event) {
        event.preventDefault()
        props.closePopup()
    };
    function handleCopy(index) {
        let copiedSlides = []

        for (let i = 0; i < includedSlides.length; i++) {
            if (i === index) {
                copiedSlides.push(includedSlides[i])
                let incObj = { "tag": findNewTagName(includedSlides[i].tag, includedSlides), "parent": includedSlides[i].tag, "imageBytes": includedSlides[i].imageBytes, "description": includedSlides[i].description }
                copiedSlides.push(incObj)
            } else {
                copiedSlides.push(includedSlides[i])
            }
        }

        setIncludedSlides(copiedSlides)
    }
    function handleDelete(tag) {
        let copiedSlides = []
        let regexCopyTest = new RegExp(' Copy [1-9]+')

        for (let i = 0; i < includedSlides.length; i++) {
            if (includedSlides[i].tag !== tag) {
                copiedSlides.push(includedSlides[i])
            }
        }

        let slideImage = props.presentationSlideChanges.slideImages.find(i => i.slideTag === tag)
        if (slideImage) {
            if (!regexCopyTest.test(tag)) {
                let excObj = { "tag": tag, "imageBytes": slideImage.imageBytes, "description": slideImage.slideDescription }
                sections.find(s => s.name === slideImage.slideSection).slides.push(excObj)
            }
        }

        setIncludedSlides(copiedSlides)
        setSections(sections)
    }
    function handleAdd(event, tag) {
        event.preventDefault()
        let toAdd = null

        // Remove tag from exluded as we are now including it
        sections.forEach(sec => {
            let slides = sec.slides
            let copiedSlides = []

            slides.forEach(slide => {
                if (slide.tag !== tag) {
                    copiedSlides.push(slide)
                } else {
                    toAdd = slide
                }
            })

            sec.slides = copiedSlides
        })

        // Add new slide to included list
        if (toAdd) {
            includedSlides.push(toAdd)
        }

        setIncludedSlides(includedSlides)
        setSections(sections)
        setForceUpdate(true)
    }
    function handleSubmit(event) {
        event.preventDefault()

        props.closePopup()
        props.updateStory(props.popupInfo.presentationId, includedSlides)
        navigate('/presentations')
    }
    function handleReorderBubbleEvent(order) {
        let includedSlides = []
        let regexCopyTest = new RegExp(' Copy [1-9]+')

        order.forEach((t) => {
            if (regexCopyTest.test(t)) {
                let matchIndex = t.match(regexCopyTest).index
                let parent = t.substr(0, matchIndex)
                let slideImage = props.presentationSlideChanges.slideImages.find(i => i.slideTag === parent)
                let incObj = { "tag": t, "parent": parent, "imageBytes": slideImage.imageBytes, "description": slideImage.slideDescription }
                includedSlides.push(incObj)
            } else {
                let slideImage = props.presentationSlideChanges.slideImages.find(i => i.slideTag === t)
                let incObj = { "tag": t, "parent": null, "imageBytes": slideImage.imageBytes, "description": slideImage.slideDescription }
                includedSlides.push(incObj)
            }
        })

        setIncludedSlides(includedSlides)
    }
    function handleResize() {
        setTimeout(() => {
            if (popupContainerRef.current !== null) {
                let newWidth = popupContainerRef.current.clientWidth - 80
                setWidth(newWidth)
            }
        }, 1)
    }
    //#endregion

    //#region State Building Events
    function buildIncludedRegion(popupInfo,loadImagesUp) {
        let includedSlides = []
        let regexCopyTest = new RegExp(' Copy [1-9]+')
        
        popupInfo.includedTags.forEach((t) => {
            let parent = null
            if (regexCopyTest.test(t)) {
                let matchIndex = t.match(regexCopyTest).index
                parent = t.substr(0, matchIndex)
            }
            let slideImage = popupInfo.slideImages.find(i => i.slideTag === t.tag)
            let imgBytes = slideImage["imageBytes"]
            let incObj = { "tag": t.tag, "parent": parent, "imageBytes": imgBytes, "description": slideImage.slideDescription }
            includedSlides.push(incObj)
        });

        setIncludedSlides(includedSlides)
    }
    function buildExcludedRegion(popupInfo,loadImagesUp) {
        let excludedSlides = []
        let sections = {}
        let sectionsStateObj = []

        popupInfo.slideImages.forEach(s => {
            let currentSection = s.slideSection
            if (!sections[currentSection]) {
                sections[currentSection] = true
            }
        })

        // Go through each key and build the objects
        Object.keys(sections).forEach(key => {
            let slidesInKey = []

            popupInfo.excludedTags.forEach((t) => {
                let slideImage = popupInfo.slideImages.find(i => i.slideTag === t && i.slideSection === key)
                if (slideImage) {
                    let imgBytes = slideImage["imageBytes"]
                    let excObj = { "tag": t, "imageBytes": imgBytes, "description": slideImage.slideDescription }
                    slidesInKey.push(excObj)
                }
            })

            sectionsStateObj.push({ "name": key, "slides": slidesInKey })
        })

        popupInfo.excludedTags.forEach((t) => {
            let slideImage = popupInfo.slideImages.find(i => i.slideTag === t)
            let excObj = { "tag": t, "imageBytes": slideImage.imageBytes, "description": slideImage.slideDescription }
            excludedSlides.push(excObj)
        })

        setExcludedSlides(excludedSlides)
        setSections(sectionsStateObj)
    }
    function findNewTagName(tag, allSlides) {
        let incrementor = 1
        let rtnVal = `${tag} Copy ${incrementor}`

        let keepIncrementing = true
        while (keepIncrementing) {
            let found = false
            for (let i = 0; i < allSlides.length; i++) {
                if (allSlides[i].tag === rtnVal) {
                    found = true
                }
            }

            if (found) {
                incrementor = incrementor + 1
                rtnVal = `${tag} Copy ${incrementor}`
            } else {
                keepIncrementing = false
            }
        }

        return rtnVal
    }
    //#endregion
}

function mapStateToProps(state) {
    return {
        popupInfo: state.ui.popupInfo,
        presentationSlideChanges: state.presentations.present.presentationSlideChanges,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ closePopup, updateStory, getPresentationSlideImage }, dispatch)
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EditStoryPopup))